import i18n from '@/locales'
export const renderComponentMap = {
  EIP_UNUSED: 'EipForm',
  DISK_UNUSED: 'DiskForm',
  LB_UNUSED: 'LbForm',
  SCALE_DOWN: 'ScaleDownForm',
  SNAPSHOT_UNUSED: 'SnapshotForm',
  SECGROUPRULEINSERVER_ALLIN: 'GroupRuleForm',
  OSS_SEC_ACL: 'OssSecAclForm',
  REDIS_UNREASONABLE: 'RedisUnreasonableForm',
  RDS_UNREASONABLE: 'RdsUnreasonableForm',
  OSS_UNREASONABLE: 'OssUnreasonableForm',
}

export const timeOptions = [
  { label: i18n.t('bill.text_46'), key: 'M' },
  { label: i18n.t('bill.text_207'), key: 'w' },
  { label: i18n.t('bill.text_3'), key: 'd' },
  { label: i18n.t('bill.text_4'), key: 'h' },
]

export const durationOptions = [
  { label: i18n.t('bill.text_48'), key: 'y' },
  { label: i18n.t('bill.text_46'), key: 'M' },
  { label: i18n.t('bill.text_207'), key: 'w' },
  { label: i18n.t('bill.text_3'), key: 'd' },
  { label: i18n.t('bill.text_4'), key: 'h' },
  { label: i18n.t('bill.text_208'), key: 'm' },
]

export const durationMaps = {}

durationOptions.forEach(({ key, label }) => {
  durationMaps[key] = label
})

export const ruleSupportEditMap = {
  EIP_UNUSED: ['period'],
  DISK_UNUSED: ['period'],
  LB_UNUSED: ['period'],
  DOWN_SIZE: ['period', 'threshold'],
  UP_SIZE: ['period', 'threshold', 'time_from'],
  SCALING_SERVER: ['period', 'threshold'],
  TIMING_OPEN_SERVER: ['period', 'threshold'],
  EXPIRE_SERVER_SKU: ['period'],
  SCALE_DOWN: ['period', 'threshold'],
  RDS_UNREASONABLE: ['period', 'threshold'],
  OSS_UNREASONABLE: ['period', 'threshold'],
  REDIS_UNREASONABLE: ['period', 'threshold', 'time_from'],
  SECGROUPRULEINSERVER_ALLIN: ['period'],
  SNAPSHOT_UNUSED: ['period'],
  OSS_SEC_ACL: ['period'],
  CLOUDACCOUNT_AMOUNT_DAILY: ['period'],
  CLOUDACCOUNT_AMOUNT_MONTH: ['period'],
  TIMING_SERVER: ['period', 'threshold', 'time_from'],
  upgrade_prepaid: ['period'],
  DOWN_SIZE_BY_MEM: ['period', 'threshold', 'time_from'],
}
